<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <input
        type="password"
        [formControl]="control"
        [id]="controlId"
        class="sh-input-field sh-form-group__input"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [required]="isControlRequired$ | async"
        [attr.autocomplete]="autocomplete || null"
        [attr.placeholder]="placeholder || null"
        [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
        [attr.aria-invalid]="isControlInvalid$ | async"
    />
</sh-form-group>
